/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Sex = "F" | "M" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PedigreeTree_otherDog$ref: FragmentReference;
declare export opaque type PedigreeTree_otherDog$fragmentType: PedigreeTree_otherDog$ref;
export type PedigreeTree_otherDog = {|
  +id: string,
  +sex: ?Sex,
  +ancestors: {|
    +nodes: $ReadOnlyArray<{|
      +dog: ?{|
        +id: string,
        +registeredName: string,
        +sex: ?Sex,
        +prefixes: ?$ReadOnlyArray<?string>,
        +suffixes: ?$ReadOnlyArray<?string>,
        +birthdate: ?string,
        +damId: ?string,
        +sireId: ?string,
      |}
    |}>
  |},
  +$refType: PedigreeTree_otherDog$ref,
|};
export type PedigreeTree_otherDog$data = PedigreeTree_otherDog;
export type PedigreeTree_otherDog$key = {
  +$data?: PedigreeTree_otherDog$data,
  +$fragmentRefs: PedigreeTree_otherDog$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sex",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "depth"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PedigreeTree_otherDog",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "depth",
          "variableName": "depth"
        }
      ],
      "concreteType": "AncestorResultsConnection",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AncestorResult",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Dog",
              "kind": "LinkedField",
              "name": "dog",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registeredName",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "prefixes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "suffixes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "birthdate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "damId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sireId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Dog",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '5bbf26192c26106f9f60941b079ed9f0';

module.exports = node;
